import { Box, Container, Typography, useTheme, useMediaQuery } from '@mui/material';

const GuestBooking = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container maxWidth="lg" sx={{ 
      px: isSmallMobile ? 2 : isMobile ? 3 : 4,
      py: isMobile ? 3 : 4 
    }}>
      <Box sx={{ 
        py: isMobile ? 3 : 4,
        textAlign: 'center'
      }}>
        <Typography 
          variant="h3" 
          component="h1" 
          gutterBottom
          sx={{
            fontSize: isSmallMobile ? '1.75rem' : isMobile ? '2.125rem' : '3rem',
            fontWeight: 600,
            mb: isMobile ? 2 : 3
          }}
        >
          Guest Booking
        </Typography>
        <Typography 
          variant="body1" 
          sx={{
            fontSize: isMobile ? '1rem' : '1.125rem',
            color: 'text.secondary',
            maxWidth: '600px',
            mx: 'auto'
          }}
        >
          {/* Add booking form and other components here */}
          Welcome to our guest booking system. Please fill out the form below to proceed with your booking.
        </Typography>
      </Box>
    </Container>
  );
};

export default GuestBooking; 